export default __webpack_public_path__ + "static/media/include_9@3x.5fdb87ed.jpg";